<template>
    <div class="disease-doctor" v-loading="loading">
        <p v-if="chartData.diseaseName" class="disease-name">当前疾病：{{ chartData.diseaseName }}</p>
        <section
            v-for="item in sections"
            :id="item.id"
            :key="item.key"
            class="doctor-section"
        >
            <div class="section-head">
                <h3 class="section-tit">{{ item.title }}</h3>
            </div>
            <div class="section-body">
                <medicine-analysis v-if="item.key === 'medicine'" :chart-data="chartData" />
                <treatment-analysis v-else-if="item.key === 'treatment'" :chart-data="chartData" />
                <pathogenesis-analysis v-else-if="item.key === 'pathogenesis'" :chart-data="chartData" />
                <diagnosis-analysis v-else-if="item.key === 'diagnosis'" :chart-data="chartData" />
            </div>
        </section>
    </div>
</template>

<script>
import MedicineAnalysis from './comps/medicine_analysis.vue';
import TreatmentAnalysis from './comps/treatment_analysis.vue';
import PathogenesisAnalysis from './comps/pathogenesis_analysis.vue';
import DiagnosisAnalysis from './comps/diagnosis_analysis.vue';
import { getDoctorInfo } from '@/io/api';
import { normalizeDoctorData } from './doctorData';

export default {
    name: 'DiseaseDoctor',
    components: {
        MedicineAnalysis,
        TreatmentAnalysis,
        PathogenesisAnalysis,
        DiagnosisAnalysis,
    },
    props: {
        // 父组件也可直接传入业务响应的 data；不传时调用 io/api.js 的请求入口。
        doctorData: { type: Object, default: null },
    },
    data() {
        return {
            loading: false,
            responseData: {},
            requestId: 0,
            sections: [
                { key: 'medicine', id: 'medicineAnalysis', title: '用药分析' },
                { key: 'treatment', id: 'treatmentAnalysis', title: '治疗分析' },
                { key: 'pathogenesis', id: 'pathogenesisAnalysis', title: '病因病机分析' },
                { key: 'diagnosis', id: 'diagnosisAnalysis', title: '诊断分析' },
            ],
        };
    },
    computed: {
        chartData() {
            return normalizeDoctorData(this.doctorData || this.responseData);
        },
    },
    watch: {
        doctorData: {
            immediate: true,
            handler(data) {
                if (data) {
                    this.requestId += 1;
                    this.loading = false;
                } else {
                    this.loadDoctorData();
                }
            },
        },
        '$route.query.word'() {
            if (!this.doctorData) this.loadDoctorData();
        },
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    methods: {
        async loadDoctorData() {
            const requestId = ++this.requestId;
            this.loading = true;
            this.responseData = {};
            try {
                // 真实接口统一在 src/io/api.js 的 getDoctorInfo 中替换。
                // 这里接收 { code, msg, data }，子组件只接收规范化后的 data。
                const response = await getDoctorInfo({ diseaseName: this.$route.query.word || '' });
                 let {code,data,msg} = response.data;
                // 疾病快速切换、外部数据接管或组件销毁后，忽略旧请求。
                if (requestId !== this.requestId) return;
                if (code!=0) {
                    this.$message.error(msg || '医生模块数据加载失败');
                }
                this.responseData = data || {};
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.$message.error(error.message || '医生模块数据加载失败，请稍后重试');
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
.disease-name {
    margin: 0 0 16px;
    color: #0C55AA;
    font-weight: bold;
}
</style>
